import React from 'react'
import styled from 'styled-components'
import colors from '../styles/colors'
import CardImage from '../images/card-cta.png'
import ContentWidth from './ContentWidth'
import media from '../styles/media'
import GlobalButton from './buttons/GlobalButton'

const HighlightedCTACard = ({ content }) => {
  return (
      <ContentWidth>
        <Card>
          <ColumnText>
            <Heading>{content?.headline}</Heading>
            <BodyText>{content?.body}</BodyText>
          </ColumnText>
          <GlobalButton href={content?.ctaLink} fill>
            {content.ctaText}
          </GlobalButton>
        </Card>
      </ContentWidth>

  )
}
const Card = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 1.944vw;
    padding: 4.167vw 6.944vw;
    border-radius: 1.667vw;
    background-image:url(${CardImage});
    background-repeat: no-repeat;
    background-size: cover;
    object-position: center center;
   

    ${media.fullWidth} {
      gap: 28px;
      padding: 60px 100px;
      border-radius: 24px;
    }
    
    ${media.tablet} {
      background-size: cover;
      background-position: left center;
      gap: 2.441vw;
      padding: 4.883vw 7.813vw;
      border-radius: 2.344vw;
    
    }
    
    ${media.mobile} {
      background-size: cover;
      background-position: left center;
      flex-direction: column;
      gap: 5.607vw;
      padding: 8.411vw 6.542vw;
      align-items: flex-start;
      border-radius: 5.607vw;
    }
`

const ColumnText = styled.div`
  color: ${colors.white};
  display: flex;
  flex-direction:column;
  gap: 1.111vw;
  width: 48.472vw;

  ${media.fullWidth} {
    gap: 16px;
    width: 698px;
  }
  
  ${media.tablet} {
    gap: 1.172vw;
    width: 55.371vw;
  }
  
  ${media.mobile} {
    gap: 1.869vw;
    width: 74.766vw;
  }
`
const Heading = styled.h3`
  font-family: Archivo;
  font-weight: 700;
  font-size: 2.361vw;
  line-height: 2.778vw;
  text-align: left;

  ${media.fullWidth} {
    font-size: 34px;
    line-height: 40px;
  }
  ${media.tablet} {
    font-size: 3.32vw;
    line-height: 3.906vw;
  }
  ${media.mobile} {
    font-size: 7.009vw;
    line-height: 8.411vw;
  }
` 
const BodyText = styled.div`
  font-family: Archivo;
  font-weight: 400;
  font-size: 1.25vw;
  line-height: 1.875vw;
  text-align: left;


  ${media.fullWidth} {
    font-size: 18px;
    line-height: 27px;
  }
  
  ${media.tablet} {
    font-size: 1.758vw;
    line-height: 2.637vw;
  }
  
  ${media.mobile} {
    font-size: 4.206vw;
    line-height: 6.308vw;
  }
`

export default HighlightedCTACard